import { CREDIT_RESTORATION_SCORE_AVERAGE_INCREASE, CREDIT_RESTORATION_SCORE_MAX } from '../constants';

export const getUsersNewPotentialCreditScore = (creditScore) => {
    return Math.min(creditScore + CREDIT_RESTORATION_SCORE_AVERAGE_INCREASE, CREDIT_RESTORATION_SCORE_MAX);
};
